import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../data.requirements";
export class PaymentManagementUseCase {
    constructor(data) {
        this.data = data;
    }
    run(data) {
        return this.data.changePayment(data);
    }
}
PaymentManagementUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PaymentManagementUseCase_Factory() { return new PaymentManagementUseCase(i0.ɵɵinject(i1.DataRequirementsInjectionToken)); }, token: PaymentManagementUseCase, providedIn: "root" });
